import PropTypes from 'prop-types'
import { ButtonCheckoutCustom } from '../../../../common/buttonCheckoutCustom'
import { BUTTON_TYPES } from '../../../../common/buttonCheckoutCustom/constants'
import { REPORT_ITEM_STATUS } from './constants'
import classes from './index.module.scss'

export const ReportItem = ({ data }) => {
  return (
    <div className="mb1">
      <div className="flexColumn justifyContentCenter">
        {data.status === REPORT_ITEM_STATUS.UNAVAILABLE && (
          <ButtonCheckoutCustom
            type={BUTTON_TYPES.UNAVAILABLE}
            className={classes.reportItemButton}
          />
        )}
      </div>
    </div>
  )
}

ReportItem.propTypes = {
  data: PropTypes.object.isRequired,
  isDomesticSearch: PropTypes.bool,
}

ReportItem.defaultTypes = {
  isDomesticSearch: true,
}
